import { makeStyles } from '@material-ui/core/styles';
import { highContrastMode } from '../../utils/highContrastChecker';

const pathFill = highContrastMode ? 'white' : 'black';

export const useStyles = makeStyles(() => ({
  sliderStyles: {
    marginBottom: '4px',
    width: '30px',
    paddingBottom: '0',
    zIndex: 100,
    position: 'relative',
    '& .MuiSlider-rail': {
      backgroundColor: '#1976d2',
      height: '16px',
      width: 'calc(100% + 12px)',
      position: 'absolute',
      top: '6px',
      left: '-5px',
      borderRadius: '10px',
      border: highContrastMode ? 'solid 1px white' : 'none',
    },
    '& .MuiSlider-thumb': {
      height: '21px',
      width: '21px',
      position: 'relative',
      top: '-5px',
      marginLeft: '-10px',
      transition: 'left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
      border: highContrastMode ? 'solid 1px white' : 'none',
      '&.MuiSlider-active': {
        boxShadow: '0px 0px 0px 4px rgb(63 81 181 / 30%)',
      },
    },
  },
  colored: {
    '& .MuiSlider-thumb': {
      backgroundColor: highContrastMode ? 'black' : '',
      '&.MuiSlider-active': {
        boxShadow: '0px 0px 0px 4px rgb(63 81 181 / 30%)',
      },
      '&:hover': {
        boxShadow: '0px 0px 0px 4px rgb(63 81 181 / 10%)',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="13" width="13" viewBox="0 0 32 32"><path fill="white" d="M 28.28125 6.28125 L 11 23.5625 L 3.71875 16.28125 L 2.28125 17.71875 L 10.28125 25.71875 L 11 26.40625 L 11.71875 25.71875 L 29.71875 7.71875 Z"/></svg>')`,
      },
    },
  },
  greyed: {
    '& .MuiSlider-thumb': {
      backgroundColor: 'white',
      boxShadow:
        '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%);',
      '&.MuiSlider-active': {},
      '&:hover': {
        boxShadow: '0px 0px 0px 4px rgb(00 00 00 / 5%)',
      },
      '&::before': {
        content: "''",
        position: 'absolute',
        width: '100%',
        height: '100%',
        left: 0,
        top: 0,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="13" width="13" viewBox="0 0 32 32"><path fill="black" d="M 7.21875 5.78125 L 5.78125 7.21875 L 14.5625 16 L 5.78125 24.78125 L 7.21875 26.21875 L 16 17.4375 L 24.78125 26.21875 L 26.21875 24.78125 L 17.4375 16 L 26.21875 7.21875 L 24.78125 5.78125 L 16 14.5625 Z" /></svg>')`,
      },
    },

    '& .MuiSlider-rail': {
      backgroundColor: '#000',
    },
    '& .MuiSlider-mark': {
      backgroundColor: 'black',
    },
  },
}));
